import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { FiscalDataId, FiscalDataService } from '../../services/fiscal-data.service';
import { Globals } from '../../globals';
import { CFDI, CustomerBillData } from '../../services/customer-bill.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PostalCodeCatalog } from '../../../catalogs/postalCode';
import { CompanyData } from '../../services/company.service';

@Component({
  selector: 'app-display-fiscal-data',
  templateUrl: './display-fiscal-data.component.html',
  styleUrls: ['./display-fiscal-data.component.css']
})
export class DisplayFiscalDataComponent implements OnInit, OnDestroy{

	cfdiForm: FormGroup;

  id: string;
  parent: string;
  customerOrSupplier: string;

  fiscalData: any;
  cfdi: CFDI;
  fiscalDataSub: Subscription;

  constructor(
		private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fiscalDataService: FiscalDataService,
    private customerBillData: CustomerBillData,
    private companyData: CompanyData,
  ) {
    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];

    this.fiscalDataSub = this.fiscalDataService.displayFiscalData(this.id).subscribe((data) => {
      let postalCodeData = PostalCodeCatalog.obj[data.postCode];
      let fiscalRegimenData = this.companyData.fiscalRegimenSelect[data.fiscalRegimen as FiscalDataId['fiscalRegimen']];
      this.fiscalData = {
        businessName: data.businessName,
        rfc: data.rfc,
        neighborhood: data.neighborhood,
        street: data.street,
        externalNumber: data.externalNumber,
        internalNumber: data.internalNumber,
        municipality: data.municipality,
        state: Globals.STATES[data.stateId].name,
        country: Globals.COUNTRIES[data.countryId].name,
        email: data.email,
        email2: data.email2,
        phone: data.phone || '',
        creditLimitAmount: data.creditLimitAmount,
        creditLimitDays: data.creditLimitDays,
        creditLimitAmountInside: data.creditLimitAmountInside,
        creditLimitDaysInside: data.creditLimitDaysInside,
        accountingCode: data.accountingCode,
        notes: data.notes,
        postCode: data.postCode || '',
        postCodeDisplay: postalCodeData ? `${postalCodeData.stateCode} - ${data.postCode}` : '',
        fiscalRegimen: fiscalRegimenData ? fiscalRegimenData.full : '',
      };
      this.cfdi = <CFDI>Object.keys(data.cfdi || {}).reduce((acc, cur) => {
        acc[cur] = cur != 'change' && cur != 'bankDigits' ? this.customerBillData[`${cur}Select`][`${data.cfdi[cur]}`].full : data.cfdi[cur];
        return acc;
      }, {});
      this.cfdiForm.patchValue(this.cfdi);
    });
  }
  	
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/fiscalData']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/fiscalData']);
		}
	}

  ngOnInit() {
    this.cfdiForm = this.formBuilder.group(<{[K in keyof CFDI]: string}>{
      payForm: '',
      payMethod: '',
      payConditions: '',
      cfdiUsage: '',
      //currency: '',
      //change: 1,
      bankDigits: ''
    });
  }
  ngOnDestroy(){
    this.fiscalDataSub.unsubscribe();
  }

}